var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.987 11.8869L15.237 3.13688C14.9089 2.80894 14.4639 2.62473 14 2.62473C13.5361 2.62473 13.0911 2.80894 12.763 3.13688L4.01298 11.8869C3.84969 12.049 3.72025 12.2419 3.63218 12.4544C3.54412 12.667 3.49919 12.8949 3.50001 13.125V23.625C3.50001 23.8571 3.5922 24.0796 3.75629 24.2437C3.92039 24.4078 4.14295 24.5 4.37501 24.5H11.375C11.6071 24.5 11.8296 24.4078 11.9937 24.2437C12.1578 24.0796 12.25 23.8571 12.25 23.625V17.5H15.75V23.625C15.75 23.8571 15.8422 24.0796 16.0063 24.2437C16.1704 24.4078 16.3929 24.5 16.625 24.5H23.625C23.8571 24.5 24.0796 24.4078 24.2437 24.2437C24.4078 24.0796 24.5 23.8571 24.5 23.625V13.125C24.5008 12.8949 24.4559 12.667 24.3678 12.4544C24.2798 12.2419 24.1503 12.049 23.987 11.8869ZM22.75 22.75H17.5V16.625C17.5 16.3929 17.4078 16.1704 17.2437 16.0063C17.0796 15.8422 16.8571 15.75 16.625 15.75H11.375C11.1429 15.75 10.9204 15.8422 10.7563 16.0063C10.5922 16.1704 10.5 16.3929 10.5 16.625V22.75H5.25001V13.125L14 4.37501L22.75 13.125V22.75Z",
    fill: "#A6ACBA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.81b350ba1a3cf98dfeaedcfa7c026542.svg";
export { ForwardRef as ReactComponent };